import { useEffect, useState } from "react";
import { HEADER_OFFSET, sectionOf } from "@/lib/scroll";

export const useScrollSpy = (ids) => {
  const [active, setActive] = useState(null);
  useEffect(() => {
    let raf = 0;
    const update = () => {
      raf = 0;
      const line = HEADER_OFFSET + window.innerHeight * 0.3;
      const hit = ids.find((id) => {
        const r = sectionOf(id)?.getBoundingClientRect();
        return r && r.top <= line && r.bottom > line;
      });
      setActive(hit || null);
    };
    const onScroll = () => { if (!raf) raf = requestAnimationFrame(update); };
    update();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    return () => { window.removeEventListener("scroll", onScroll); window.removeEventListener("resize", onScroll); cancelAnimationFrame(raf); };
  }, [ids]);
  return active;
};
